// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"101":"55b09bcf","696":"50f6d062"}[chunkId] + ".css";
};